import ServicoBuscaSession from "./servicoBuscaSession";

const TEMPO_LIMITE_SDK_MS = 10000;
let sdkPendente = null;
let avisoSdkIndisponivelExibido = false;
let avisoInicializacaoParcialExibido = false;

function obterSdkProntoParaTracking() {
    if (typeof window === "undefined" || !window.buscarService) {
        return null;
    }

    const sdk = window.buscarService;
    const configuracao = sdk.config || {};
    const metodosDisponiveis =
        typeof sdk.enviarLogClick === "function" &&
        typeof sdk.enviarLogPagina === "function";
    const contextoDisponivel =
        configuracao.smarthintkey &&
        configuracao.session &&
        configuracao.SmartHint_AnonymousConsumer;

    return metodosDisponiveis && contextoDisponivel ? sdk : null;
}

function avisarInicializacaoParcial() {
    const sdkInicializado =
        window.servicobusca && window.servicobusca.sdkInicializado;

    if (!sdkInicializado && !avisoInicializacaoParcialExibido) {
        avisoInicializacaoParcialExibido = true;
        console.info(
            "[ServicoBusca] SDK disponivel para tracking explicito; a inicializacao automatica foi ignorada."
        );
    }
}

function aguardarSdk() {
    if (typeof window === "undefined") {
        return Promise.reject(new Error("SDK indisponivel fora do navegador."));
    }

    const sdkDisponivel = obterSdkProntoParaTracking();

    if (sdkDisponivel) {
        avisoSdkIndisponivelExibido = false;
        avisarInicializacaoParcial();
        return Promise.resolve(sdkDisponivel);
    }

    if (sdkPendente) {
        return sdkPendente;
    }

    sdkPendente = new Promise((resolve, reject) => {
        let tempoLimite = null;
        let verificacaoSdk = null;

        const limparEspera = () => {
            window.removeEventListener("SDK_DICOMP_CARREGADO", sdkCarregado);
            clearTimeout(tempoLimite);
            clearInterval(verificacaoSdk);
        };

        const concluirSeDisponivel = () => {
            const sdkPronto = obterSdkProntoParaTracking();

            if (!sdkPronto) {
                return false;
            }

            limparEspera();
            avisarInicializacaoParcial();
            resolve(sdkPronto);
            return true;
        };

        const sdkCarregado = (event) => {
            if (event.detail && event.detail.nome !== "ServicoBusca") {
                return;
            }

            concluirSeDisponivel();
        };

        window.addEventListener("SDK_DICOMP_CARREGADO", sdkCarregado);
        verificacaoSdk = setInterval(concluirSeDisponivel, 100);

        tempoLimite = setTimeout(() => {
            limparEspera();
            reject(new Error("Tempo limite excedido ao aguardar o SDK."));
        }, TEMPO_LIMITE_SDK_MS);
    }).then(
        (sdk) => {
            sdkPendente = null;
            avisoSdkIndisponivelExibido = false;
            return sdk;
        },
        (error) => {
            sdkPendente = null;
            return Promise.reject(error);
        }
    );

    return sdkPendente;
}

function avisarFalha(error) {
    if (!avisoSdkIndisponivelExibido) {
        avisoSdkIndisponivelExibido = true;
        console.warn("[ServicoBusca] Nao foi possivel enviar o tracking.", error);
    }

    return false;
}

function executar(metodo, dados) {
    return aguardarSdk()
        .then((sdk) => {
            if (typeof sdk[metodo] !== "function") {
                throw new Error(`Metodo ${metodo} indisponivel no SDK.`);
            }

            sdk[metodo](dados);
            return true;
        })
        .catch(avisarFalha);
}

function enviarClick(dados) {
    const dadosClick = Object.assign({}, dados || {});
    const evento = dadosClick.evento;

    delete dadosClick.evento;

    if (evento) {
        const item = Array.isArray(evento.itens) ? evento.itens[0] : null;

        dadosClick.idProduto = item ? item.codigoProduto : undefined;
        dadosClick.precoProduto =
            item && item.preco !== undefined && item.preco !== null
                ? item.preco
                : 0;
        dadosClick.termo =
            evento.termo !== undefined && evento.termo !== null
                ? evento.termo
                : "";
    }

    if (!dadosClick.searchId) {
        dadosClick.searchId = ServicoBuscaSession.obterSearchId() || null;
    }

    return executar("enviarLogClick", dadosClick);
}

function enviarPagina(dados) {
    return executar("enviarLogPagina", Object.assign({}, dados || {}));
}

export default {
    enviarClick,
    enviarPagina
};
